<template>
  <div class="container is-fluid">
    <button class="button">{{ applications.length }} applications</button>
    
    <div class="field is-pulled-right" v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('director') || $auth.user.roles.includes('admin'))">
       <div class="select ">
            
            <select  v-model="roundId" @change="changeRound()" >
                <option value="0">Select Funding Round ...</option>
                <option v-for="row in rounds" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
       
        <div class="select ">
            
            <select  v-model="governingBodyId"  >
                <option value="0">Select Governing Body ...</option>
                <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
         <div class="select ">
            
            <select  v-model="councilAreaId"  >
                <option value="0">Select Council Area ...</option>
                <option v-for="row in council_areas" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
    </div>

    
    
    <table class="table is-hoverable is-fullwidth" id="councilAreaReport">
    	<thead>
    		<th>Name</th>
        <th>Governing Body</th>
          <th>Status</th>
          <th >Amount</th>
          
    	</thead>
    	
		    <CouncilAreaList v-for="council_area in council_areas" :key="council_area.id" :council-area-name="council_area.name" :council-area-id="council_area.id" :applications="applications"/>
      
    
    </table>
    
    <div class="buttons">
    <button class="button is-link" @click="exportPDF()">Export Results to PDF</button>
    <button class="button is-success" @click="exportXLS()">Export Results to Excel</button>
    </div>
    

  </div>
</template>

<script>

import CouncilAreaList from '@/components/Reports/CouncilAreaList';
import ApplicationService from '@/services/ApplicationService.js';
import { jsPDF } from "jspdf";
import 'jspdf-autotable'
import XLSX from 'xlsx';

export default {
  components: {
   	CouncilAreaList
  },
  data() {
    return {
      orders: [],
      errors: [],
      applications: [],
      governing_bodies:[],
      council_areas:[],
      rounds: [],
      orderBy:"",
      governingBodyId: 0,
      councilAreaId: 0,
      roundId:process.env.VUE_APP_CURRENT_ROUND_ID,
    }
  },
  
  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
        this.getApplications();
      this.getGoverningBodies();
      this.getCouncilAreas();
       this.getRounds();
    });
  },
  watch: {
    '$route'() {
     this.getApplications();
    
    },
    governingBodyId: function() {
      this.getApplications();
      
    },
    councilAreaId: function() {
      this.getApplications();
     
    },
    roundId: function() {
      this.getApplications();
     
    }
  },
  methods: {
  	async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
    async getGoverningBodies() {
        
      ApplicationService.getGoverningBodies("")
      .then(
        (governing_bodies => {
          this.$set(this, "governing_bodies", governing_bodies);
        }).bind(this)
      );
    },
    async getCouncilAreas() {
       
      ApplicationService.getCouncilAreas("")
      .then(
        (council_areas => {
          this.$set(this, "council_areas", council_areas);
        }).bind(this)
      );
    },
    async getRounds() {
       
      ApplicationService.getRounds(this.accessToken)
      .then(
        (rounds => {
          this.$set(this, "rounds", rounds);
        }).bind(this)
      );
    },
    async getApplications() {
     
      var status = "awarded"
      if(this.$route.params.status != "" && this.$route.params.status != undefined)
      {
         status = this.$route.params.status 
      }

      // Use the eventService to call the getEventSingle() method
      ApplicationService.getApplications(this.accessToken, status, this.governingBodyId, this.councilAreaId, this.orderBy, this.roundId)
      .then(
        (applications => {
          this.$set(this, "applications", applications);
        }).bind(this)
      );
    },
    exportPDF()
    {
      var doc = new jsPDF('portrait', 'mm', 'a4');
      doc.setFontSize(20);
      
      doc.autoTable({ html: '#councilAreaReport', useCss: true   })

      doc.save('ApplicationsByCouncilArea.pdf');
    },
     exportXLS() {
        //alert("hi")
        var wb = XLSX.utils.table_to_book(document.getElementById('councilAreaReport'), {sheet:"Sheet JS"});
        XLSX.writeFile(wb, 'awards-by-council-area.xlsx')

    },
    
    
  }
}


</script>

<style>
	
</style>
